import cn from 'classnames';
import { HTMLAttributes } from 'react';
import { Card } from '@/shared/ui/core';
import styles from './registration-card.module.scss';


export function RegistrationCard (
    { className, compact, wide, ...props }: HTMLAttributes<HTMLDivElement> & { compact?: boolean, wide?: boolean }
) {
    return (
        <Card
            className={ cn(styles.root, { [styles.compact]: compact, [styles.wide]: wide }, className) }
            data-template='registration-card'
            { ...props }
        />
    );
}
